export class PopInfoDto {
  cisloPop: string;
  druhRm: number;
  rokZrani: number;
  dodavatelId: number;
}
